module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "product-wrap"
  }, [_c('view-box', [_c('m-product-nav', {
    attrs: {
      "scroll-top": _vm.scrollTop,
      "offset-top": _vm.navOffsetTop,
      "active": _vm.active,
      "show": _vm.showFixedNav
    },
    on: {
      "fixedNavChange": function (value) {
        _vm.showFixedNav = value
      },
      "clickNav": _vm.onClickNav
    }
  }), _vm._v(" "), _c('m-tab-layout', {
    ref: "scroller",
    staticClass: "product",
    attrs: {
      "scrollTo": _vm.scrollTo
    },
    on: {
      "scroll": _vm.onScroll
    }
  }, [_c('div', {
    slot: "scroller"
  }, [_c('m-product-header', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }), _vm._v(" "), _c('div', {
    ref: "nav",
    staticClass: "nav"
  }, [_c('m-product-nav', {
    attrs: {
      "scroll-top": _vm.scrollTop,
      "offset-top": _vm.navOffsetTop,
      "active": _vm.active,
      "show": !_vm.showFixedNav
    },
    on: {
      "fixedNavChange": function (value) {
        _vm.showFixedNav = value
      },
      "clickNav": _vm.onClickNav
    }
  })], 1), _vm._v(" "), _c('m-intro', {
    ref: "nav1",
    staticStyle: {
      "margin-bottom": "10px"
    },
    on: {
      "on-recordScroll": _vm.recordScroll,
      "on-openDialog": _vm.onShowWhat
    }
  }), _vm._v(" "), _c('m-question', {
    ref: "nav2",
    staticStyle: {
      "margin-bottom": "10px"
    },
    on: {
      "on-reActiveNav": _vm.reActiveNav
    }
  }), _vm._v(" "), _c('m-message', {
    ref: "nav3",
    staticStyle: {
      "margin-bottom": "10px"
    },
    on: {
      "on-reActiveNav": _vm.reActiveNav,
      "on-messageReady": _vm.messageReady
    }
  }), _vm._v(" "), _c('m-process', {
    ref: "nav4",
    staticStyle: {
      "margin-bottom": "10px"
    },
    on: {
      "on-recordScroll": _vm.recordScroll
    }
  })], 1)]), _vm._v(" "), _c('tabbar', {
    staticClass: "bottom",
    slot: "bottom"
  }, [_c('m-buy', {
    attrs: {
      "measureState": _vm.measureState
    },
    on: {
      "clickBuy": _vm.onClickBuy
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "measure-wrap",
    class: {
      'measure-wrap--active': _vm.measureState
    }
  }, [_c('m-measure', {
    on: {
      "close": function () {
        _vm.measureState = false
      }
    }
  }), _vm._v(" "), _c('tabbar', {
    staticClass: "bottom"
  }, [_c('m-buy', {
    attrs: {
      "measureState": _vm.measureState
    },
    on: {
      "clickBuy": _vm.onClickBuy
    }
  })], 1)], 1), _vm._v(" "), _c('x-dialog', {
    staticClass: "show-what",
    attrs: {
      "hide-on-blur": ""
    },
    model: {
      value: (_vm.showWhat),
      callback: function($$v) {
        _vm.showWhat = $$v
      },
      expression: "showWhat"
    }
  }, [_c('div', {
    staticClass: "close"
  }, [_c('span', [_vm._v("3+5按需定制")]), _vm._v(" "), _c('span', {
    staticClass: "vux-close",
    on: {
      "click": _vm.onCloseWhat
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "show-what-body"
  }, [_c('p', [_vm._v("3种交费方式：5年、10年、20年;")]), _vm._v(" "), _c('p', [_vm._v("5种保险期间：20年、30年、至60岁、至65岁、至70岁;")]), _vm._v(" "), _c('p', [_vm._v("自由组合")])])]), _vm._v(" "), _c('confirm', {
    staticClass: "agent",
    attrs: {
      "value": _vm.showAgent,
      "title": "统计业绩需要，请正确填写以下信息",
      "close-on-confirm": false
    },
    on: {
      "on-confirm": _vm.onConfirmAgent
    }
  }, [_c('group', [_c('x-input', {
    attrs: {
      "show-clear": false,
      "title": "姓名",
      "placeholder": "请输入姓名",
      "placeholder-align": "right",
      "text-align": "right"
    },
    on: {
      "on-blur": _vm.checkAgentName
    },
    model: {
      value: (_vm.agentName),
      callback: function($$v) {
        _vm.agentName = $$v
      },
      expression: "agentName"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "show-clear": false,
      "title": "工号",
      "placeholder": "请输入工号",
      "placeholder-align": "right",
      "text-align": "right"
    },
    on: {
      "on-blur": _vm.checkAgentJobNum
    },
    model: {
      value: (_vm.agentJobNum),
      callback: function($$v) {
        _vm.agentJobNum = $$v
      },
      expression: "agentJobNum"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f3c415a"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Product.vue
// module id = 646
// module chunks = 1